import React from 'react';
import './BasicLayout.scoped.css';

const BasicLayout: React.FC = ({children}) => (
  <div className="grid grid-cols-12 gap-0 h-screen">
    <div className="md:col-span-12">
      <div className="layoutContent">{children}</div>
    </div>
  </div>
);

export default BasicLayout;
